import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactModule } from './contact/contact.module';
import { GalleryModule } from './gallery/gallery.module';
import { TavernModule } from './tavern/tavern.module';
import { AmenitiesModule } from './amenities/amenities.module';
import { ApartmentsModule } from './apartments/apartments.module';
import { ResortModule } from './resort/resort.module';
import { HomeModule } from './home/home.module';
import { ApartmentOneModule } from './apartment-one/apartment-one.module';
import { ApartmentThreeModule } from './apartment-three/apartment-three.module';
import { ApartmentTwoModule } from './apartment-two/apartment-two.module';

@NgModule({
  imports: [
    CommonModule,
    HomeModule,
    ResortModule,
    ApartmentsModule,
    AmenitiesModule,
    TavernModule,
    GalleryModule,
    ContactModule,
    ApartmentOneModule,
    ApartmentTwoModule,
    ApartmentThreeModule
  ],
  declarations: []
})
export class PagesModule { }



// WEBPACK FOOTER //
// ./src/app/pages/pages.module.ts